<template>
    <div class="item_sidebar _toggle" :class="itemClass">
        <div class="wrapper_title mb_0">
            <div class="title">{{title}}</div>

            <label class="switch_checkbox_item">
                <input type="checkbox" :checked="value" @change="updatedData($event.target.checked)">
                <div class="switch_checkbox"><span></span></div>
            </label>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Toggle',
    props: ['title', 'value'],
    methods: {
        updatedData(val){
            this.$emit('updated', val);
        },
    },
	computed:{
		itemClass() {
			return this.title.toLowerCase().split(' ').join('_');
		}
	}
}
</script>
<style lang="scss" scoped>
._toggle {

}
</style>
